import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table,  Breadcrumb } from 'react-bootstrap';
import { InputField } from '../Common/inputField';
import { Field } from 'redux-form';
import _ from 'lodash';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';

class RowRenderer extends Component {

    PropTypes: {
      onDoubleClick: React.PropTypes.func
    }

    render() {
        return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

class GroupManagementDetail extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            dirty: false,

            groups: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            userGroups: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            permissions: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            userPermissions: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null
            }
        };
        this.moveToUserPermissions = this.moveToUserPermissions.bind(this);
        this.moveOffUserPermissions = this.moveOffUserPermissions.bind(this);
    }

    componentDidMount() {
      if(this.props.params.id) {
        this.props.fetchGroupDetail(this.props.params.id)
          .then(() => {
              this.props.fetchPermissions();
          });
      }
      else {
        this.props.fetchPermissions();
      }
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.groupDetail && nextProps.groupDetail != this.props.groupDetail) {
        let userPermissions = {...this.state.userPermissions, rows: nextProps.groupDetail.permissions};
        let permissions = {...this.state.permissions};
        userPermissions.rows.map(
          row => {
            let index = _.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
            if(index > -1)
              permissions.rows.splice(index, 1);
          }
        );
        this.setState({userPermissions, permissions});
      }
      if (nextProps.permissions && nextProps.permissions != this.props.permissions) {
        let newRows = [...nextProps.permissions];
        let permissions = {...this.state.permissions, rows: newRows }
        let { userPermissions } = this.state;
        userPermissions.rows.map(
          row => {
            let index = _.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
            if(index > -1)
              permissions.rows.splice(index, 1);
          }
        );
        this.setState({permissions});
      }
      if (nextProps.groups && nextProps.groups != this.props.groups) {
        let newRows = [...nextProps.groups];
        let groups = {...this.state.groups, rows: newRows }
        this.setState({groups});
      }
    }

    renderGroups() {
        if (this.props.groupsIsLoading && !this.props.groupsError) return <Spinner/>
        else if (this.props.groupsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.groupsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.groups);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var groups = Object.assign({}, this.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({groups});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.groups.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const groups = {...this.state.groups, filters: newFilters};
                this.setState({ groups });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = [...this.state.groups.rows];
                 let selectedRows = [];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                   selectedRows.push(r.row);
                 });
                 if(this.state.groups.selectedRows)
                    selectedRows = selectedRows.concat(this.state.groups.selectedRows);
                 var groups = {...this.state.groups, rows: newRows, selectedRows: selectedRows}
                 this.setState({groups});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = [...this.state.groups.rows];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 let selectedRows = [...this.state.groups.selectedRows];
                 selectedRows = selectedRows.filter(function(obj){
                    return obj.isSelected == true;
                 })
                 var groups = {...this.state.groups, rows: newRows, selectedRows: selectedRows};
                 this.setState({groups});
             }

             const onRowClick = (rowIdx, row) => {
                //  this.props.fetchUserDetail(row.user_id);
             }

            // Column difinition

            const columns = [
              {
                  key: 'name',
                  name: 'group name',
                  resizable: true,
                  width: 220,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Col sm={ 5 }><div style={{ maxWidth: '99%' }} id="GroupManagementDetail-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={ getSize() }
                        onRowClick={onRowClick}
                        enableRowSelect='multi'
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}
                       />
                </div></Col>
            )
        }
    }

    renderUserGroups() {
        if (this.props.groupsIsLoading && !this.props.groupsError) return <Spinner/>
        else if (this.props.groupsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.groupsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.userGroups);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var userGroups = Object.assign({}, this.state.userGroups, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({userGroups});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.userGroups.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const userGroups = {...this.state.userGroups, filters: newFilters};
                this.setState({ userGroups });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = [...this.state.userGroups.rows];
                 let selectedRows = [];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                   selectedRows.push(r.row);
                 });
                 if(this.state.userGroups.selectedRows)
                    selectedRows = selectedRows.concat(this.state.userGroups.selectedRows);
                 var userGroups = {...this.state.userGroups, rows: newRows, selectedRows: selectedRows}
                 this.setState({userGroups});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = [...this.state.userGroups.rows];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 let selectedRows = [...this.state.userGroups.selectedRows];
                 selectedRows = selectedRows.filter(function(obj){
                    return obj.isSelected == true;
                 })
                 var userGroups = {...this.state.userGroups, rows: newRows, selectedRows: selectedRows};
                 this.setState({userGroups});
             }

             const onRowClick = (rowIdx, row) => {
                //  this.props.fetchUserDetail(row.user_id);
             }

            // Column difinition

            const columns = [
              {
                  key: 'name',
                  name: 'group name',
                  resizable: true,
                  width: 220,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Col sm={ 5 }><div style={{ maxWidth: '99%' }} id="GroupManagementDetail-dataGrid2">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={ getSize() }
                        onRowClick={onRowClick}
                        enableRowSelect='multi'
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}
                       />
                </div></Col>
            )
        }
    }

    renderPermissions() {
        if (this.props.permissionsIsLoading && !this.props.permissionsError) return <Spinner/>
        else if (this.props.permissionsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.permissionsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.permissions);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var permissions = Object.assign({}, this.state.permissions, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({permissions});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.permissions.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const permissions = {...this.state.permissions, filters: newFilters};
                this.setState({ permissions });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = [...this.state.permissions.rows];
                 let selectedRows = [];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                   selectedRows.push(r.row);
                 });
                 if(this.state.permissions.selectedRows)
                    selectedRows = selectedRows.concat(this.state.permissions.selectedRows);
                 var permissions = {...this.state.permissions, rows: newRows, selectedRows: selectedRows}
                 this.setState({permissions});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = [...this.state.permissions.rows];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 let selectedRows = [...this.state.permissions.selectedRows];
                 selectedRows = selectedRows.filter(function(obj){
                    return obj.isSelected == true;
                 })
                 var permissions = {...this.state.permissions, rows: newRows, selectedRows: selectedRows};
                 this.setState({permissions});
             }

             const onRowClick = (rowIdx, row) => {
                //  this.props.fetchUserDetail(row.user_id);
             }

            // Column difinition

            const columns = [
              {
                  key: 'name',
                  name: <Translate value="permission_name" />,
                  width: 220,
                  resizable: true,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Col sm={ 6 }><div style={{ maxWidth: '100%' }} id="GroupManagementDetail-dataGrid3">
                    <ReactDataGrid
                        rowRenderer={<RowRenderer onDoubleClick={this.moveToUserPermissions} />}
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        minHeight={605}
                        rowGetter={rowGetter}
                        rowsCount={ getSize() }
                        onRowClick={onRowClick}
                      //   enableRowSelect='multi'
                      //   rowSelection={{
                      //     showCheckbox: true,
                      //     enableShiftSelect: true,
                      //     onRowsSelected: onRowsSelected,
                      //     onRowsDeselected: onRowsDeselected,
                      //     selectBy: {
                      //      isSelectedKey: 'isSelected'
                      //     }
                      //  }}
                       />
                </div></Col>
            )
        }
    }

    renderUserPermissions() {
        if (this.props.permissionsIsLoading && !this.props.permissionsError) return <Spinner/>
        else if (this.props.permissionsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.permissionsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.userPermissions);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var userPermissions = Object.assign({}, this.state.userPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({userPermissions});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.userPermissions.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const userPermissions = {...this.state.userPermissions, filters: newFilters};
                this.setState({ userPermissions });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = [...this.state.userPermissions.rows];
                 let selectedRows = [];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                   selectedRows.push(r.row);
                 });
                 if(this.state.userPermissions.selectedRows)
                    selectedRows = selectedRows.concat(this.state.userPermissions.selectedRows);
                 var userPermissions = {...this.state.userPermissions, rows: newRows, selectedRows: selectedRows}
                 this.setState({userPermissions});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = [...this.state.userPermissions.rows];
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 let selectedRows = [...this.state.userPermissions.selectedRows];
                 selectedRows = selectedRows.filter(function(obj){
                    return obj.isSelected == true;
                 })
                 var userPermissions = {...this.state.userPermissions, rows: newRows, selectedRows: selectedRows};
                 this.setState({userPermissions});
             }

             const onRowClick = (rowIdx, row) => {
                //  this.props.fetchUserDetail(row.user_id);
             }

            // Column difinition

            const columns = [
              {
                  key: 'name',
                  name: <Translate value="permission_name" />,
                  resizable: true,
                  width: 220,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Col sm={ 6 }><div style={{ maxWidth: '100%' }} id="GroupManagementDetail-dataGrid4">
                    <ReactDataGrid
                        rowRenderer={<RowRenderer onDoubleClick={this.moveOffUserPermissions} />}
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        minHeight={605}
                        rowGetter={rowGetter}
                        rowsCount={ getSize() }
                        onRowClick={onRowClick}
                      //   enableRowSelect='multi'
                      //   rowSelection={{
                      //     showCheckbox: true,
                      //     enableShiftSelect: true,
                      //     onRowsSelected: onRowsSelected,
                      //     onRowsDeselected: onRowsDeselected,
                      //     selectBy: {
                      //      isSelectedKey: 'isSelected'
                      //     }
                      //  }}
                       />
                </div></Col>
            )
        }
    }

    moveToUserPermissions(permission) {
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let newRows = [...this.state.permissions.rows];
      let index = _.findIndex(newRows, {id: permission.id});
      if(index > -1)
        newRows.splice(index, 1);
      userPermissionsRows.push(permission);
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userPermissions: userPermissions, permissions: permissions});
    }

    moveOffUserPermissions(permission) {
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let newRows = [...this.state.permissions.rows];
      let index = _.findIndex(userPermissionsRows, {id: permission.id});
      if(index > -1)
        userPermissionsRows.splice(index, 1);
      newRows.push(permission);
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userPermissions: userPermissions, permissions: permissions});
    }

    moveToUserGroups() {
      let userGroupsRows = [...this.state.userGroups.rows];
      let newRows = [...this.state.groups.selectedRows];
      newRows.map((row) => {
          row.isSelected = false;
      })
      let newUserGroupsRows = [];
      newRows.map((row) => {
          var obj = Object.assign({}, row);
          newUserGroupsRows.push(obj);
      })
      userGroupsRows = userGroupsRows.concat(newUserGroupsRows);
      let userGroupsRowsUnique = [];

      userGroupsRows.map( row => {
          var index = _.findIndex(userGroupsRowsUnique, {'id': row.id});
          if(index == -1)
            userGroupsRowsUnique.push(row);
      })
      let userGroups = {...this.state.userGroups, rows: userGroupsRowsUnique};
      let groups = {...this.state.groups, selectedRows: []};
      this.setState(...this.state, {userGroups: userGroups, groups: groups});
    }

    moveOffUserGroups() {
      let userGroupsRows = [...this.state.userGroups.rows];
      userGroupsRows = userGroupsRows.filter(function(obj){
          return obj.isSelected == false || obj.isSelected == null;
      })
      let userGroups = {...this.state.userGroups, rows: userGroupsRows, isSelected: []};
      this.setState(...this.state, {userGroups: userGroups});
    }

    handleFormSubmit(formProps) {
      this.setState({ dirty: false });
      if(this.props.currentGroup) {
        if(checkPermission("change_group")){
          this.props.editGroupDetail(this.props.currentGroup, formProps, this.state.userPermissions.rows);
        }else
          alert("You have no permission!");
      }
      else {
        this.props.createGroupDetail(formProps, this.state.userPermissions.rows);
      }
    }

    render() {
        const { handleSubmit, submitting, pristine } = this.props;
        return (
            <ContentWrapper>
              <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) }>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="admin" />
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Translate value="role_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="user_detail" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <ButtonToolbar>
                <Button type="submit" bsStyle="success" ><em className="fa fa-save"/> <Translate value="save" />
                </Button>
                <Button bsStyle="danger" onClick={()=>{this.context.router.push('/groupManagement')}}><em className="fa fa-close"/>
                </Button>
              </ButtonToolbar>
              <Grid id="group-management-detail">
                {/* <div className="content-heading"><Translate value="user_detail" /></div> */}
                    <Row className="marginBottomStyle" >
                      <Panel>
                        <Col sm={ 6 }>
                          <Col sm={ 3 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="role_name" /></label></Col>
                            <Col sm={ 6 } style={{float: "left"}}>
                              <Field name="name" component={ InputField }/>
                            </Col>
                        </Col>
                      </Panel>
                    </Row>
                    <Row>
                      <Panel id="group-management-detail-permissions">
                        { this.renderPermissions() }
                        {/* <Col sm={ 2 }>
                          <Button className="btn btn-primary" onClick={ this.moveToUserPermissions.bind(this) }><i/> <Translate value="move_to" />
                          </Button>
                          <Button className="btn btn-primary" onClick={this.moveOffUserPermissions.bind(this)}><i/> <Translate value="move_off" />
                          </Button>
                        </Col> */}
                        { this.renderUserPermissions() }
                      </Panel>
                    </Row>
                </Grid>
              </form>
          </ContentWrapper>
        )
    }

}

export default GroupManagementDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/groupManagementDetail.jsx